import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import './forgotpass.css'
import { useNavigate } from 'react-router-dom';
function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();
  const handleResetPassword = async () => {
    const auth = getAuth();
    try {
      // Send a password reset email to the user's email address
      await sendPasswordResetEmail(auth, email);
      setResetEmailSent(true);
    } catch (error) {
      console.error('Error sending password reset email:', error.message);
    }
  };

  return (
    <div>
      <h2>Forgot Password</h2>
      {resetEmailSent ? (
        <p className='message'>Password reset email sent. Check your email for further instructions.</p>
      ) : (
        <div>
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <button onClick={handleResetPassword} className='resetbtn'>Reset Password</button>
        </div>
      )}
      <p>
        Remember your password? <Link to="/login">Login</Link>
      </p>
    </div>
  );
}

export default ForgotPassword;
